import { FC, ReactNode } from "react"

import { Box, SxProps, Theme, Typography } from "@mui/material"

import {
  ssoContentRootSx,
  ssoIconCellSx,
  ssoTextCellSx,
} from "./ssoButton.styles"

interface SsoButtonContentProps {
  icon: ReactNode
  text: string
  iconSx?: SxProps<Theme>
}

const SsoButtonContent: FC<SsoButtonContentProps> = ({
  icon,
  text,
  iconSx,
}) => (
  <Box sx={ssoContentRootSx}>
    <Box sx={[ssoIconCellSx, iconSx].filter(Boolean) as SxProps<Theme>}>
      {icon}
    </Box>
    <Box sx={ssoTextCellSx}>
      <Typography component="span" display="block" noWrap>
        {text}
      </Typography>
    </Box>
  </Box>
)

export default SsoButtonContent
